import { transformSubtitles } from '@/scenarios/legacy-player/components/movie-player/transformers/transform-subtitles';

import { getNotNullableItems } from '../../../lib/get-not-nullable-items';

import { useCurrentTrailerStream } from './use-current-trailer-stream';

export const useTrailerSubtitles = (contentId: string) => {
    const stream = useCurrentTrailerStream(contentId);

    const subtitles = getNotNullableItems(stream?.streamMeta?.subtitleMetas);

    return transformSubtitles(subtitles);
};
